/*
Purpose: Snapshot counters shown above the Calendar (v2) grid.
*/

import React from 'react';
import PropTypes from 'prop-types';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';

function Stat({ value, label, variant, isLive }) {
  const className = ['cv2-stat', variant ? `cv2-stat--${variant}` : ''].filter(Boolean).join(' ');

  return (
    <div className={className}>
      <span className="cv2-stat__value">
        {isLive ? <span className="cv2-live-dot" /> : null}
        {value}
      </span>
      <span className="cv2-stat__label">{label}</span>
    </div>
  );
}

Stat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['live', 'danger']),
  isLive: PropTypes.bool,
};

Stat.defaultProps = {
  variant: undefined,
  isLive: false,
};

/**
 * @param {Object} props
 * @param {{lessonCount:number, sessionCount:number, ongoingCount:number, attentionCount:number, flexiCount:number}} props.stats
 * @param {string} props.centreName Shown on the right of the strip.
 */
export default function StatsStrip({ stats, centreName }) {
  return (
    <div className="cv2-stats">
      <Stat value={stats.sessionCount} label="Sessions" />
      <Stat value={stats.lessonCount} label="Students" />
      <Stat value={stats.ongoingCount} label="Ongoing now" variant="live" isLive />
      <Stat value={stats.attentionCount} label="Deferred / Missed" variant="danger" />
      <Stat value={stats.flexiCount} label="Flexi" />

      {centreName ? (
        <div className="cv2-stats__centre">
          <PlaceOutlinedIcon className="cv2-icon" />
          <strong>{centreName}</strong>
        </div>
      ) : null}
    </div>
  );
}

StatsStrip.propTypes = {
  stats: PropTypes.shape({
    lessonCount: PropTypes.number.isRequired,
    sessionCount: PropTypes.number.isRequired,
    ongoingCount: PropTypes.number.isRequired,
    attentionCount: PropTypes.number.isRequired,
    flexiCount: PropTypes.number.isRequired,
  }).isRequired,
  centreName: PropTypes.string,
};

StatsStrip.defaultProps = {
  centreName: '',
};
